import { clsx } from 'clsx';
import { useCardDrift } from '../../hooks/use-card-drift';
import styles from './assistant-card.module.css';

/** Floating assistant/chat product card for the onboarding constellation. */
export function AssistantCard() {
  const ref = useCardDrift({ amp: 9, speed: 0.09, phase: 2.3 });

  return (
    <div
      ref={ref as React.RefObject<HTMLDivElement>}
      className={styles.card}
    >
      <div className={styles.cardhead}>
        {/* Spark/star icon for the assistant */}
        <svg className={styles.sparkIcon} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <path d="M12 2l1.6 5.2L19 9l-5.4 1.8L12 16l-1.6-5.2L5 9l5.4-1.8L12 2z" />
        </svg>
        <span className={styles.label}>Assistant</span>
        <span className={styles.windowDots}>
          <span className={styles.windowDot} />
          <span className={styles.windowDot} />
          <span className={styles.windowDot} />
        </span>
      </div>

      <div className={styles.cardbody}>
        <div className={clsx(styles.bubble, styles.bubbleUser)}>
          Summarize my standup
        </div>
        <div className={clsx(styles.bubble, styles.bubbleAi)}>
          Three decisions, with an owner for each
          <span className={styles.caret} aria-hidden />
        </div>
      </div>
    </div>
  );
}
